import React, { useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Config } from '../../common/config';
import { translations } from '../../data/translation';

export default function PwdSearchDone(props) {
  const language = useSelector(state => state.language.language);
  const t = translations[language];

  useEffect(() => {}, []);

  return (
    <>
      <section className="location_box">
        <ul className="location_001">
          <li>{t.home}</li>
          <li>{t.pwdSearch}</li>
        </ul>
      </section>

      <main>
        <section className="contants_box_04">
          <article className="signup_07">
            <h2 className="tit_01">{t.pwdSearch}</h2>
          </article>

          <article className="contants_box_03">
            <div className="signup_07_001">
              {t.pwdSearchDoneFull}
            </div>
          </article>

          <div className="signup_08">
            <article className="button_box_01">
              <NavLink to="/">
                <button
                  type="button"
                  className="button_01 button_07 button_gray_line"
                >
                  {t.home}
                </button>
              </NavLink>
              <NavLink to={`${Config.SHOPADMIN_SERVER}/login`}>
                <button
                  type="button"
                  className="button_01 button_07 button_red"
                >
                  {t.login}
                </button>
              </NavLink>
            </article>
          </div>
        </section>
      </main>
    </>
  );
}
